module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "PhyStore"
  }, [_c('navbar', {
    attrs: {
      "transparent": _vm.isTransparent,
      "activeTo": "Home"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "PhyStore-Content"
  }, [_c('h1', {
    staticClass: "store-title"
  }, [_vm._v(_vm._s(_vm.$t('footer_Resellers')))]), _vm._v(" "), _c('Row', [_vm._l((_vm.StoreList), function(item, index) {
    return _c('i-col', {
      key: index,
      attrs: {
        "lg": 8,
        "md": 8,
        "sm": 12,
        "xs": 24
      }
    }, [_c('div', {
      staticClass: "PhyStore-col",
      on: {
        "click": function($event) {
          _vm.Goshop(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "PhyStore-wrap"
    }, [_c('h1', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('img', {
      attrs: {
        "src": item.img
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "PhyStore-address"
    }, [_c('h3', {
      staticClass: "font_mid"
    }, [_vm._v(_vm._s(_vm.$t('shop_address')) + "：")]), _vm._v(" "), _c('p', {
      staticClass: "font_mid"
    }, [_vm._v(_vm._s(item.address))])]), _vm._v(" "), _c('div', {
      staticClass: "PhyStore-time"
    }, [_c('h3', {
      staticClass: "font_mid"
    }, [_vm._v(_vm._s(_vm.$t('shop_hours')) + "：")]), _vm._v(" "), _c('div', {
      staticClass: "font_mid"
    }, [_c('p', {
      staticClass: "time"
    }, [_c('label', [_vm._v(_vm._s(_vm.$t('monday_friday')))]), _vm._v(" "), _c('span', [_vm._v("10:00 a.m ~ 9:00 p.m")])])])])])])])
  }), _vm._v(" "), _c('i-col', {
    attrs: {
      "lg": 8,
      "md": 8,
      "sm": 12,
      "xs": 24
    }
  }, [_c('img', {
    staticClass: "phystore-img",
    attrs: {
      "src": require("../../assets/coming_soon.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "phystore-tip"
  }, [_vm._v(_vm._s(_vm.$t('iretail_coming_tip')))])])], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-812e6d3e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Store/PhysicalStore.vue
// module id = 835
// module chunks = 0